import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Consulting(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="GCP Services">
                            <h2>What You Get From TekRevol’s Google Cloud Services</h2>
                        </div>
                        {/*<div*/}
                        {/*    className="main_para"><p>TekRevol's SAP consulting can help you customize SAP*/}
                        {/*    functionalities and match them with your business requirements and future scalability goals.*/}
                        {/*    You can add or accelerate features, combine functionalities, and put features into action*/}
                        {/*    according to your organizational structure and goals with compatible coding solutions.</p>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Google Cloud Management</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Google Cloud Implementation Consultancy</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Development with Google Cloud</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>TekRevol's Google Cloud Management services assist businesses update their cloud procedures with cutting-edge tools and technologies. We guarantee that your cloud infrastructure is improved for performance, cost-efficiency, and scalability, so that you can emphasis on your main business ideas.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Our Google Cloud Implementation Consultancy services aid businesses migrate to the cloud impeccably, guaranteeing that their data is safe, manageable, and compliant. Our knowledge and skill in Google Cloud Platform warrants that businesses can force the full potential of cloud technology to determine business development and modernization.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>TekRevol's Development with Google Cloud services support businesses develop and organize scalable and flexible applications on the cloud. With our proficiency in Google Cloud Platform, businesses can influence progressive tools and technologies to develop advance solutions that meet their exceptional business requirements.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Google Cloud Management</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Google Cloud Management services assist businesses update their cloud procedures with cutting-edge tools and technologies. We guarantee that your cloud infrastructure is improved for performance, cost-efficiency, and scalability, so that you can emphasis on your main business ideas.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Google Cloud Implementation Consultancy</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our Google Cloud Implementation Consultancy services aid businesses migrate to the cloud impeccably, guaranteeing that their data is safe, manageable, and compliant. Our knowledge and skill in Google Cloud Platform warrants that businesses can force the full potential of cloud technology to determine business development and modernization.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Development with Google Cloud</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Development with Google Cloud services support businesses develop and organize scalable and flexible applications on the cloud. With our proficiency in Google Cloud Platform, businesses can influence progressive tools and technologies to develop advance solutions that meet their exceptional business requirements.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Consulting;